import './icon-tabs.pcss';
import './icon-tabs';